import {
  FETCH_SUPER_STOKEZES_REQUEST,
  FETCH_SUPER_STOKEZES_SUCCESS,
  FETCH_SUPER_STOKEZES_FAILURE,
  CREATE_SUPER_STOKEZ_SUCCESS,
  UPDATE_SUPER_STOKEZ_SUCCESS,
  DELETE_SUPER_STOKEZ_SUCCESS,
  TOGGLE_LOCK_SUPER_STOKEZ_SUCCESS,
  TOGGLE_DELETE_SUPER_STOKEZ_SUCCESS
} from '../actions/superStokezActions';
import { PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER } from '../actions/transferBalancePatchActions';

const initialState = {
  superStokezes: [],
  loading: false,
  error: null
};

const superStokezReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUPER_STOKEZES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SUPER_STOKEZES_SUCCESS:
      return { ...state, loading: false, superStokezes: action.payload, error: null };
    case FETCH_SUPER_STOKEZES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_SUPER_STOKEZ_SUCCESS:
      if (!action.payload) return state;
      return { ...state, superStokezes: [...state.superStokezes, action.payload] };
    case UPDATE_SUPER_STOKEZ_SUCCESS:
    case TOGGLE_LOCK_SUPER_STOKEZ_SUCCESS:
    case TOGGLE_DELETE_SUPER_STOKEZ_SUCCESS:
      return {
        ...state,
        superStokezes: state.superStokezes.map(superStokez =>
          superStokez._id === action.payload._id ? action.payload : superStokez
        )
      };
    case DELETE_SUPER_STOKEZ_SUCCESS:
      return {
        ...state,
        superStokezes: state.superStokezes.filter(superStokez => superStokez._id !== action.payload)
      };
    case PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER: {
      const { username, balance } = action.payload;
      if (username == null || balance == null) return state;
      return {
        ...state,
        superStokezes: state.superStokezes.map((s) =>
          s.username === username ? { ...s, balance } : s
        ),
      };
    }
    default:
      return state;
  }
};

export default superStokezReducer;